import { JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class CreateUploadResponse {
    @JsonProperty("upload_identifier")
    uploadIdentifier: string;

    @JsonProperty("file_identifier")
    fileIdentifier: string;

    @JsonProperty("storage_identifier")
    storageIdentifier: string;
}
